module.exports = __webpack_public_path__ + "assets/img/img-map-kagoshima.9405a107.svg";